/* useIsDesktop — returns true when the viewport matches the Tailwind
 * `lg` breakpoint (≥ 1024px). Used to avoid mounting the desktop-only
 * cases table on mobile devices (previously `hidden lg:block` kept the
 * whole desktop DOM tree in the vdom just to CSS-hide it). */
import { useSyncExternalStore } from "react";

const QUERY = "(min-width: 1024px)";

function subscribe(cb) {
  if (typeof window === "undefined" || !window.matchMedia) return () => {};
  const mql = window.matchMedia(QUERY);
  const handler = () => cb();
  // addEventListener is the modern API — falls back to addListener on
  // very old Safari (iOS 13-) that we don't officially support anymore
  // but it's a one-liner so keep it just in case.
  if (mql.addEventListener) mql.addEventListener("change", handler);
  else mql.addListener(handler);
  return () => {
    if (mql.removeEventListener) mql.removeEventListener("change", handler);
    else mql.removeListener(handler);
  };
}

function snapshot() {
  if (typeof window === "undefined" || !window.matchMedia) return false;
  return window.matchMedia(QUERY).matches;
}

// SSR-safe snapshot — mobile-first default matches our CSS mobile-first
// approach so there's no hydration flicker on the mobile UI.
function serverSnapshot() { return false; }

export default function useIsDesktop() {
  return useSyncExternalStore(subscribe, snapshot, serverSnapshot);
}
